export enum PaymentsTag {
  Amount = 'amount',
  Date = 'date',
  ExpireDate = 'expireDate',
  InvoiceId = 'invoiceId',
  Price = 'price',
  Quantity = 'quantity',
  State = 'state'
}

export const PaymentsTagsMap = new Map<PaymentsTag, { tag: string; prop: string }>([
  [PaymentsTag.State, { tag: 'State', prop: 'State' }],
  [PaymentsTag.Quantity, { tag: 'Quantity', prop: 'Quantity' }],
  [PaymentsTag.Price, { tag: 'Price', prop: 'Price' }],
  [PaymentsTag.Amount, { tag: 'Amount', prop: 'Amount' }],
  [PaymentsTag.Date, { tag: 'Date', prop: 'Date' }],
  [PaymentsTag.ExpireDate, { tag: 'Expires', prop: 'ExpireDate' }],
  [PaymentsTag.InvoiceId, { tag: 'Invoice id', prop: 'OrderId' }]
]);
